import React from "react";
import { connect } from "react-redux";
import InputLabel from "@mui/material/InputLabel";
import "../../../Dashboard/dashboard.css";
import { useEffect } from "react";
import { generateCapitalizationOfEarnings } from "../../../../store/modules/capitalizationOfEarnings/actions";
import { rowStyle } from "../../../Dashboard/customStyles";
import BVAInput from "../../../../components/BVAInput/BVAInput";


const CapitalizationOfEarnings = ({
  capitalizationOfEarnings,
  appState,
  dispatchGenerateCapitalizationOfEarnings
}) => {
  // Mounted
  useEffect(() => {
    dispatchGenerateCapitalizationOfEarnings()
  }, [])


  return (
    <>
      <h2 className="sectionHead">Capitalization Of Earnings</h2>
        <div className="dashboard-content">
          <div className="data-title-container">
            <div></div>

            <div className="data-title">
              <h6>{appState.companyData.name}</h6>
              <p>After-Tax Capitalization of Earnings</p>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>After-Tax Free Cash Flow</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="capearning-afterTaxCapitalizationOfEarnings-afterTaxFreeCashFlow"
                startAdornment
                startAdornmentLabel="$"
                value={capitalizationOfEarnings?.afterTaxFreeCashFlow}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>
                After-Tax Net Cash Flow Capitalization Rate %
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="capearning-afterTaxCapitalizationOfEarnings-afterTaxNetCashFlowCapitalizationRate"
                endAdornment
                endAdornmentLabel="%"
                value={capitalizationOfEarnings?.afterTaxNetCashFlowCapitalizationRate}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Capitalized Earnings of Subject Company
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="cashearning-afterTaxCapitalizationOfEarnings-predictedFactor"
                startAdornment
                startAdornmentLabel="$"
                value={capitalizationOfEarnings?.afterTaxCapitalizedEarningsOfSubjectCompany}
              />
            </div>
          </div>

          <div className="data-title-container pt-7">
            <div></div>

            <div className="data-title">
              <h6>{appState.companyData.name}</h6>
              <p>Before-Tax Capitalization of Earnings</p>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Pre-Tax Free Cash Flow</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="capearning-beforeTaxCapitalizationOfEarnings-preTaxFreeCashFlow"
                startAdornment
                startAdornmentLabel="$"
                value={capitalizationOfEarnings?.preTaxFreeCashFlow}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>
                Pre-Tax Net Cash Flow Capitalization Rate (%)
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="capearning-beforeTaxCapitalizationOfEarnings-preTaxNetCashFlowCapitalizationRate"
                endAdornmentLabel="%"
                endAdornment
                value={capitalizationOfEarnings?.preTaxNetCashFlowCapitalizationRate}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Capitalized Earnings of Subject Company
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="capearning-beforeTaxCapitalizationOfEarnings-capitalizedEarningsOfSubjectCompany"
                startAdornment
                startAdornmentLabel="$"
                value={capitalizationOfEarnings?.beforeTaxCapitalizedEarningsOfSubjectCompany}
              />
            </div>
          </div>

          <div className="data-title-container pt-7">
            <div></div>

            <div className="data-title">
              <h6>{appState.companyData.name}</h6>
              <p>Capitalization of Pre-Tax Income</p>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>
                Earnings Before Interest & Taxes (EBIT)
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="capearning-capitalizationOfPreTaxIncome-ebit"
                startAdornment
                startAdornmentLabel="$"
                value={capitalizationOfEarnings?.ebit}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Pre-Tax Net Income Capitalization Rate %</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="capearning-capitalizationOfPreTaxIncome-preTaxNetIncomeCapitalizationRate"
                endAdornmentLabel="%"
                endAdornment
                value={capitalizationOfEarnings?.preTaxNetIncomeCapitalizationRate}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Capitalized Earnings of Subject Company
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="capearning-capitalizationOfPreTaxIncome-capitalizedEarningsOfSubjectCompany"
                startAdornment
                startAdornmentLabel="$"
                value={capitalizationOfEarnings?.preTaxCapitalizedEarningsOfSubjectCompany}
              />
            </div>
          </div>
        </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    capitalizationOfEarnings: state.capitalizationOfEarnings.capitalizationOfEarnings,
    taxes: state.taxes,
    appState: state.appState,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateCapitalizationOfEarnings() {
    dispatch(generateCapitalizationOfEarnings())
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(CapitalizationOfEarnings);
